import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import ATRProductTable from "./ATRProductTable";
import { usePageStyles } from "../../pageStyles";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import {
  DownloadButtonProduct,
  DownloadExcelButtonProduct,
} from "./DownloadButton";
import { annualTradesReportLocation } from "./Locations";
import { RouteComponentProps } from "react-router-dom";
import { useCurrentTradesReportFilter } from "../../../data/reports/annualTrade/hooks/useTradesReportFilter";

export interface ATRProductPageInfo {
  year: string;
}

export interface ATRProductPageProps
  extends RouteComponentProps<ATRProductPageInfo> {
  userAccessRights: AccessRights;
}

const ATRProductPage: React.FunctionComponent<ATRProductPageProps> = (
  props
) => {
  const pageStyles = usePageStyles();

  // ovde su parametri za izvestaj
  // zbog toga stho se uzimaju iz URL-a moraju biti tipa string, ali ih konvertujem u number zbog toga sto to trazi API
  // dalje ih treba proslediti u odgovarajuci hook da bi se sacuvali u filteru u redux store-u
  const yearNumber = Number(props.match.params.year);
  console.log("Report params:", yearNumber);

  const [filter, setReportDate, setReportYear] = useCurrentTradesReportFilter();

  React.useEffect(() => setReportYear(yearNumber), [yearNumber]);

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={
                <PageTitle
                  title="aTReportProductTitle"
                  backLocation={annualTradesReportLocation}
                />
              }
              action={<AnnualActions />}
            />
            <Divider />
            <CardContent>
              <ATRProductTable userAccessRights={props.userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const AnnualActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <DownloadButtonProduct />
    </Grid>
    <Grid item>
      <DownloadExcelButtonProduct />
    </Grid>
  </Grid>
);

export default ATRProductPage;
